import {PEER} from './peer.js';
import {PERSISTENCE, L} from "./util.js";


class peerstats {
 constructor(pc) {
  this.pc = pc;
  this.audio = {
   send: { total:0 },
   recv: { total:0 },
   packetsLost: 0
  };
  this.video = {
   send: { total:0 },
   recv: { total:0 },
   packetsLost: 0
  };
  this.peer_audiolevel = 0;
  this.self_audiolevel = 0;
  this.connection = {};
  this.imbuers = {
   "inbound-rtp|audio|undefined":
    this.imbue_rtp.bind(this,this.audio.recv,this.audio,'bytesReceived'),
   "outbound-rtp|audio|undefined":
    this.imbue_rtp.bind(this,this.audio.send,this.audio,'bytesSent'),
   "inbound-rtp|video|undefined":
    this.imbue_rtp.bind(this,this.video.recv,this.video,'bytesReceived'),
   "outbound-rtp|video|undefined":
    this.imbue_rtp.bind(this,this.video.send,this.video,'bytesSent'),
   "candidate-pair|undefined|undefined":
    this.imbue_candidates.bind(this),
   "media-source|audio|undefined":
    this.imbue_audiolevel.bind(this,'self_audiolevel'),
   "track|audio|true":
    this.imbue_audiolevel.bind(this,'peer_audiolevel')
  };
  this.imbuer = this.imbue.bind(this);
 }
 statistics() {
  return Object.assign(
   {
    id: this.pc.id,
    audiolevel: this.peer_audiolevel,
    self_audiolevel: this.self_audiolevel,
    upload: (this.audio.send.current||0)+(this.video.send.current||0),
    download: (this.audio.recv.current||0)+(this.video.recv.current||0),
    total_bytes_sent: (this.audio.send.total||0)+(this.video.send.total||0),
    total_bytes_recv: (this.audio.recv.total||0)+(this.video.recv.total||0),
    packets_lost: (this.audio.packetsLost||0)+(this.video.packetsLost||0),
    cRTT: this.connection.cRTT||0,
    tRTT: this.connection.tRTT||0,
    available_outgoing_bitrate: this.connection.available_outgoing_bitrate||0
   },
   this.pc.remote_stream && { sid:this.pc.remote_stream.id }
  );
 }
 reset_levels() {
  this.self_audiolevel = 0;
  this.peer_audiolevel = 0;
 }
 imbue(r) {
  const imbuer = this.imbuers[''+r.type+'|'+r.kind+'|'+r.remoteSource];
  if(imbuer) imbuer(r);
 }
 // eslint-disable-next-line class-methods-use-this
 imbue_rtp(data,outerdata,bytescount,r) {
  const dt = data.last && (r.timestamp-data.last);
  const bytes = r[bytescount];
  if(bytes) {
   if(dt) data.current = (bytes-data.total)*1000/dt;
   data.total = bytes;
   data.last = r.timestamp;
  }
  /* XXX: Not sure how beautiful (and correct) it is */
  if(r.packetsLost) outerdata.packetsLost = r.packetsLost;
 }
 imbue_candidates(r) {
  if(r.availableOutgoingBitrate===undefined) return;
  this.connection = {
   available_outgoing_bitrate: r.availableOutgoingBitrate,
   tRTT: r.totalRoundTripTime,
   cRTT: r.currentRoundTripTime
  };
 }
 imbue_audiolevel(target,r) {
  this[target] = r.audioLevel?r.audioLevel*100:0;
 }

 async collect() {
  this.reset_levels();
  for(const s of
   this.pc.getReceivers().concat(this.pc.audiosender,this.pc.videosender)
  ) if(s) (await s.getStats()).forEach(this.imbuer);
 }
}

let statter_timeout = null;

async function statter() {
 statter_timeout=null;
 try {
  for(const p of Object.values(PEER.connections)) {
   const ps = p.stats;
   if(!ps) continue;
   await ps.collect();
   p.statistics = ps.statistics();
  }
 }catch(e) {
  L.error(e);
 }finally{
  statter_timeout=setTimeout(statter,1000);
 }
}

function start() {
 setImmediate(()=>{
  const bstatsenabled=PERSISTENCE.get("speaker_detection",true);
  if(bstatsenabled) {
   Object.values(PEER.connections).forEach((pc)=>{
    if(!pc.stats) pc.stats = new peerstats(pc);
   });
   (statter_timeout===null) && statter();
  }else stop();
 });
}
function stop(peerid){
 if(peerid===undefined) {
  Object.values(PEER.connections).forEach(x=>delete x.stats);
  if(statter_timeout) {
   clearTimeout(statter_timeout);
   statter_timeout = undefined;
  }
 }else delete (PEER.connections[peerid]||{}).stats;
}

export const STATS = {
 is_on:false,
 start: start,
 stop: stop
};
/* vim:set ts=8 sw=1 expandtab: */
